<template>
  <div
    id="komtim-onboarding-container"
    class="h-screen bg-white"
  >
    <iframe
      frameborder="1"
      height="100%"
      width="100%"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/onboarding/komtim`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
import secureLs from '@/libs/secureLs'

export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const { type, route, data } = event.data

        if (type === 'ERR_FINISH_ONBOARDING') {
          this.$toast_error({ message: 'Gagal menyimpan data onboarding. Silakan coba lagi.' })
        }

        if (data) {
          const currentUser = secureLs.getItem('userData')
          const partnerDetail = currentUser.partner_detail

          Object.assign(partnerDetail, data.partner_detail)
          Object.assign(currentUser, data)
          Object.assign(currentUser, { partner_detail: partnerDetail })
          secureLs.setItem('userData', JSON.stringify(currentUser))
        }

        if (route) {
          this.$router.replace(route)
        }
      }
    },
  },
}
</script>
